// components/Tab.js
import { useState } from 'react';
import useEventStore, { events } from '../stores/eventStore';
import styles from './tab.module.scss';

export const Tab = () => {
	const [hoveredIndex, setHoveredIndex] = useState(null);
	const { activeTab, setActiveTab } = useEventStore();

	return (
		<div className={styles.navWrapper}>
			<div className={styles.nav}>
				{events.map((event, index) => {
					const isActive = activeTab === event.topic;
					const isHover = hoveredIndex === index;
					return (
						<div
							key={index}
							onClick={() => setActiveTab(event.topic)}
							onMouseEnter={() => setHoveredIndex(index)}
							onMouseLeave={() => setHoveredIndex(null)}
							className={`${styles.navItem} ${isActive ? styles.active : ''}`}
							data-index={index + 1}
						>
							<div className={styles.navItemWrapper}>
								<div
									className={`${styles.iconImg} ${
										isActive ? styles.active : ''
									} ${isHover ? styles.hover : ''}`}
									data-index={index + 1}
								/>
								<div className={styles.navText}>
									<label className={isActive ? styles.active : ''}>
										{event.topic}
									</label>
									<div
										className={`${styles.dateTime} ${
											isActive ? styles.active : ''
										}`}
									>
										{event.date}
										<div
											className={`${styles.dateWeek} ${
												isActive ? styles.active : ''
											}`}
										>
											六
										</div>
									</div>
								</div>
								<div
									className={`${styles.navArrow} ${
										isActive || isHover ? styles.active : ''
									}`}
								/>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};
